import { statusCodes } from '../config/statusCodes'

export const getStatusName = (statusCode: number): string => {
  let status = 'Fail'

  Object.entries(statusCodes).forEach(([statusName, statusCodes]) => {
    if (statusCodes.includes(statusCode)) {
      status = statusName
    }
  })

  return status
}
